import _ from '../../core/utils'
const floatedCtaConfig = {
    el: document.querySelector( '.section--default-floated-cta' )
}

export default floatedCtaConfig